var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "route-users" }, [
    _c(
      "div",
      { staticClass: "padding-box" },
      [
        _c(
          "cms-heading",
          {
            staticClass: "page-heading",
            attrs: { level: "1", title: "Gebruikers", icon: "magicon-user" },
          },
          [
            _vm.isAdmin
              ? _c(
                  "cms-button",
                  {
                    attrs: {
                      color: "positive",
                      icon: "magicon-plus",
                      route: "user-add",
                    },
                  },
                  [_vm._v("Gebruiker toevoegen")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "cms-heading",
          { attrs: { level: "2", title: "Alle gebruikers" } },
          [
            _c("cms-searchbar", {
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            }),
            _vm.isAdmin
              ? _c(
                  "cms-button",
                  {
                    attrs: {
                      color: "medium-dark",
                      type: "bordered",
                      icon: "magicon-plus",
                    },
                    on: { click: _vm.openAssignProjectModal },
                  },
                  [_vm._v("Toewijzen aan project")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c("cms-pagination", {
          staticClass: "top-pagination",
          attrs: { pages: _vm.pageCount },
          model: {
            value: _vm.page,
            callback: function ($$v) {
              _vm.page = $$v
            },
            expression: "page",
          },
        }),
        _c(
          "cms-table",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              "item-count": _vm.totalItems,
              clickable: "true",
              "items-per-page": _vm.itemsPerPage,
              page: _vm.page,
              offset: _vm.offset,
              placeholder: _vm.users && !_vm.users.items.length,
            },
            on: { page: _vm.switchPage },
          },
          [
            _c(
              "cms-table-header",
              [
                _c(
                  "cms-th",
                  { attrs: { width: "5%" } },
                  [
                    _c("cms-checkbox", {
                      attrs: { value: _vm.allVisibleUsersSelected },
                      on: { input: _vm.toggleAllVisibleUsers },
                    }),
                  ],
                  1
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "email" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("E-mail")]
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "firstName" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Voornaam")]
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "lastName" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Achternaam")]
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "role" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Rol")]
                ),
                _c(
                  "cms-th",
                  {
                    attrs: { field: "lastLoginDate" },
                    model: {
                      value: _vm.sort,
                      callback: function ($$v) {
                        _vm.sort = $$v
                      },
                      expression: "sort",
                    },
                  },
                  [_vm._v("Laatste login")]
                ),
                _c("cms-th"),
              ],
              1
            ),
            _vm._l(_vm.allUsers, function (user) {
              return _c(
                "tr",
                {
                  class: { selected: _vm.checkedUserIds.indexOf(user.id) >= 0 },
                  on: {
                    click: function ($event) {
                      return _vm.navigateUserEdit(user.id)
                    },
                  },
                },
                [
                  _c(
                    "td",
                    {
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("cms-checkbox", {
                        attrs: {
                          value: _vm.checkedUserIds.indexOf(user.id) >= 0,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onUserToggle(user.id)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("td", [_vm._v(_vm._s(user.email))]),
                  _c("td", [_vm._v(_vm._s(user.firstName))]),
                  _c("td", [_vm._v(_vm._s(user.lastName))]),
                  _c("td", [_vm._v(_vm._s(_vm._f("userRole")(user.role)))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("empty")(
                          _vm._f("date")(user.lastLoginDate, "LLL")
                        )
                      )
                    ),
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("cms-link", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Wijzigen",
                            expression: "'Wijzigen'",
                          },
                        ],
                        attrs: {
                          icon: "img icon-table-pencil-dark",
                          to: { name: "user-edit", params: { id: user.id } },
                        },
                      }),
                      _vm.isAdmin
                        ? _c("cms-link", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Verwijderen",
                                expression: "'Verwijderen'",
                              },
                            ],
                            attrs: { icon: "img icon-table-cross-dark" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteUser(user)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }